<template id="cmsForm">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item">
          <a href="/cms">article</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          article form
        </li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-10">
        <h3>Article Form</h3>
      </div>
    </div>
    <form>
      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Thumbnail</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img
              v-if="form.thumbnail.url != ''"
              :src="form.thumbnail.url"
              alt=""
              class="img-thumbnail"
            />
          </div>
        </div>
        <div class="col-md-7">
          <!-- <SelectThumbnail v-model="medias" :selected="{}" :medias="medias" @searchMedias="searchMedias"></SelectThumbnail> -->
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ thumbnail</label>
            <searchbox @searchButtonClick="seachThumbnail"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image
                  :dataImages="thumbnails"
                  :useLabel="true"
                  :w="'80px'"
                  :limit="41"
                  @onselectimage="onSelectImage"
                >
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a
              id="post_add_thumbnail"
              href="/media/form"
              target="_blank"
              class="btn btn-secondary form-control"
              >เพิ่มภาพใหม่</a
            >
          </div>
        </div>
      </div>

      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">ข้อมูลทั่วไป</h3>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8">
          <div class="form-group">
            <label for="post_category_id">ประเภท (category) *</label>
            <select class="form-control" v-model="form.category_id">
              <option></option>
              <option
                v-for="category in categories"
                v-bind:key="category.id"
                :value="category.id"
              >
                {{ category.name }}
              </option>
            </select>
            <!-- <form-error
              :isError="validateError.category_id.error"
              :errorMessage="validateError.category_id.message"
            ></form-error> -->
            <span v-if="errors['category_id']" class="text-danger">{{ errors['category_id'][0] }}</span>
          </div>
        </div>

        <!-- <div class="col-md-8">
                    <div class="form-group">
                        <label for="post_category_id">ประเภท (category)</label>
                        <SelectCategories v-model="categories" :selected="categories" :categories="categories" @searchCategories="searchCategories"></SelectCategories>        
                        <form-error :isError="validateError.category_id.error" :errorMessage="validateError.category_id.message"></form-error>
                    </div>
                </div> -->

        <div class="col-md-4">
          <div class="form-group">
            <label for="post_status">สถานะ *</label>
            <select class="form-control" v-model="form.status">
              <option></option>
              <option :value="'published'">published</option>
              <option :value="'draft'">draft</option>
              <option :value="'disabled'">disabled</option>
              <option :value="'trash'">trash</option>
            </select>
            <!-- <form-error
              :isError="validateError.status.error"
              :errorMessage="validateError.status.message"
            ></form-error> -->
            <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-md-4">
          <div class="form-group">
            <label for="post_allow_comment">อนุญาตแสดงความเห็น *</label>
            <select class="form-control" v-model="form.comment_status">
              <option></option>
              <option :value="'allow'">อนุญาต</option>
              <option :value="'disallow'">ไม่อนุญาต</option>
            </select>
            <form-error
              :isError="validateError.comment_status.error"
              :errorMessage="validateError.comment_status.message"
            ></form-error>
          </div>
        </div> -->
        <div class="col-md-4">
          <div class="form-group">
            <label for="post_slug required">slug *</label>
            <input type="text" class="form-control" v-model="form.slug" />
            <!-- <form-error
              :isError="validateError.slug.error"
              :errorMessage="validateError.slug.message"
            ></form-error> -->
            <span v-if="errors['slug']" class="text-danger">{{ errors['slug'][0] }}</span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="post_type required">ชนิด *</label>
            <select
              class="form-control"
              aria-describedby="post_type_Help"
              v-model="form.post_type"
            >
              <option></option>
              <option :value="'post'">Post</option>
              <option :value="'page'">Page</option>
            </select>
            <!-- <form-error
              :isError="validateError.post_type.error"
              :errorMessage="validateError.post_type.message"
            ></form-error> -->
            <span v-if="errors['post_type']" class="text-danger">{{ errors['post_type'][0] }}</span>
          </div>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-md-12">
          <div class="form-group float-right">
            <a
              href="javascript:void(0)"
              onclick="javascript:window.history.back(); return false;"
              class="btn btn-secondary"
              >ยกเลิก</a
            >
            <button
              type="button"
              class="btn btn-primary ml-5"
              @click="saveWithGoBack()"
            >
              บันทึก
            </button>
            <button
              type="button"
              v-if="!this.item_id"
              class="btn btn-primary ml-5"
              @click="saveWithMore()"
            >
              บันทึก และ บันทึกเพิ่ม
            </button>
          </div>
        </div>
      </div> -->

      <div class="row">
        <div class="col-md-12 mt-4">
          <div class="row">
            <div class="col-md-12">
              <h3 class="text text-secondary">เนื้อหาในแต่ละภาษา *</h3> 
              <div class="text-danger">(* จะต้องใส่ข้อมูลใน H1 และ Title สำหรับ th-TH และ en-UK ก่อนจึงจะสามารถบันทึกได้)</div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ul class="nav nav-tabs">
                <li
                  class="nav-item"
                  v-for="(language, langIdx) in form.languages"
                  :key="langIdx"
                >
                  <a
                    class="nav-link"
                    href="javascript:void(0);"
                    @click="languageTabClicked(langIdx)"
                    v-bind:class="{ active: form.languages[langIdx].clicked }"
                  >
                    {{ language.name }} ({{ language.code }})
                    
                  </a> 
                </li>
              </ul>
            </div>
          </div>

          <div class="row pt-1">
            <div class="col-md-12 p-4">
              <div class="tab-content">
                <div
                  class="tab-pane"
                  v-for="(language, langIdx) in form.languages"
                  :key="language.id"
                  v-bind:class="{ active: form.languages[langIdx].clicked }"
                  :id="'language_content_' + langIdx"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <p>
                        เนื้อหาในภาษา {{ language.name }} ({{ language.code }}) 
                      </p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Topic(H1) *</label> 
                        <input default="H1"
                          type="text"
                          class="form-control"
                          v-model="language.h1"
                        />
                        <!-- <form-error
                          :isError="validateError.languages.error"
                          :errorMessage="'ยังไม่ได้ใส่ข้อมูล H1 นะจ๊ะ'"
                        ></form-error> -->
                        <span v-if="errors['languages.' + langIdx + '.h1']" class="text-danger">{{ errors['languages.' + langIdx + '.h1'][0] }}</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Excerpt</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.excerpt"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>title *</label> 
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.title"
                        />
                        <span v-if="errors['languages.' + langIdx + '.title']" class="text-danger">{{ errors['languages.' + langIdx + '.title'][0] }}</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>description</label>
                        <textarea
                          type="text"
                          class="form-control"
                          v-model="language.meta_description"
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:title</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.og_title"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:description</label>
                        <textarea
                          type="text"
                          class="form-control"
                          v-model="language.og_description"
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>meta keyword</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.meta_keyword"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:site_name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.og_sitename"
                        />
                      </div>
                    </div>
                    
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>canonical</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.canonical"
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>link_rel_alternate_hreflang</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.link_rel_alternate_hreflang"
                        />
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label>og:url</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.og_url"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image_width</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.og_image_width"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image_height</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.og_image_height"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image</label>
                        <input 
                          type="text"
                          class="form-control"
                          v-model="language.og_image"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image_type</label>
                        <input 
                          type="text"
                          class="form-control"
                          v-model="language.og_image_type"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>twitter:site</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.twitter_site"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>twitter:domain</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.twitter_domain"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>twitter:card</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.twitter_card"
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>twitter:creator</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.twitter_creator"
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>twitter:title</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.twitter_title"
                        />
                      </div>
                    </div>
                  </div>

                  <SelectTags
                    v-model="language.tags"
                    :language="language"
                    :selected="language.tags"
                    :tags="tags"
                    @searchTags="searchTags"
                  ></SelectTags>

                  <div class="form-group">
                    <label>structured data</label>
                    <textarea
                      row="6"
                      type="text"
                      class="form-control"
                      v-model="language.structured_data"
                    ></textarea>
                  </div>

                  <!-- <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:locale</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="language.og_locale"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                          <SelectTags
                        v-model="language.tags"
                        :language="language"
                        :selected="language.tags"
                        :tags="tags"
                        @searchTags="searchTags"
                      ></SelectTags>
                    </div>
                  </div> -->

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>header(For old Artricle(dev))</label>
                        <textarea
                          row="6"
                          class="form-control"
                          v-model="language.header"
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <!-- <SelectTags
                    v-model="language.tags"
                    :language="language"
                    :selected="language.tags"
                    :tags="tags"
                    @searchTags="searchTags"
                  ></SelectTags> -->

                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs">
                            <li
                              class="nav-item"
                              v-for="(
                                contentPart, partIdx
                              ) in language.language_parts"
                              :key="partIdx"
                            >
                              <a
                                :href="'#' + 'language_part_' + partIdx"
                                class="nav-link"
                                @click="
                                  onContentPartTabClicked(
                                    langIdx,
                                    partIdx,
                                    $event
                                  )
                                "
                                v-bind:class="{ active: contentPart.clicked }"
                              >
                                ส่วนที่ {{ contentPart.id }}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="tab-content">
                            <div
                              class="tab-pane"
                              v-for="(
                                contentPart, partIdx
                              ) in language.language_parts"
                              :key="partIdx"
                              v-bind:class="{ active: contentPart.clicked }"
                            >
                              <div class="row">
                                <div class="col-md-12 text text-secondary">
                                  เนื้อหา {{ language.code }} ส่วนที่
                                  {{ contentPart.id }}
                                </div>
                              </div>
                              <!-- <div class="row">
                                                                <div class="col-md-12" :id="'language_part_'+partIdx">
                                                                    <vue-editor 
                                                                        v-if="false"
                                                                        @change="onEditorChange($event,langIdx,partIdx)" 
                                                                        :editorOptions="editorOption" 
                                                                        :content="contentPart.content"
                                                                        v-model="form.languages[langIdx].language_parts[partIdx].content"
                                                                    ></vue-editor>
                                                                </div>
                                                            </div> -->
                              <div class="row">
                                <div class="col-md-12">
                                  <iframe
                                    :id="
                                      'iframe_language_' +
                                      language.id +
                                      '_part_' +
                                      partIdx
                                    "
                                    :src="
                                      base_url +
                                      '/' +
                                      item_id +
                                      '/language/' +
                                      language.id +
                                      '/' +
                                      partIdx +
                                      '/' +
                                      (form.languages[langIdx].language_parts[
                                        partIdx
                                      ].content == ''
                                        ? 'n'
                                        : 'y')
                                    "
                                    height="800px"
                                    width="100%"
                                    type="application/html"
                                    frameborder="0"
                                    scrolling="no"
                                    font-family = "IBM Plex Sans Thai, sans-serif"
                                  ></iframe>
                                  <!-- <input type="hidden" :id="'input_language_'+language.id+'_part_'+partIdx"
                                                                        v-model="form.languages[langIdx].language_parts[partIdx].content"
                                                                    > -->
                                </div>

                              </div>

                              <SelectSkus
                              v-if="skus.length > 0"
                                v-model="form.languages[langIdx].language_parts[partIdx].skus"
                                :language="language"
                                :selected="form.languages[langIdx].language_parts[partIdx].skus"
                                :skus="skus"
                                :partIdx="partIdx"
                                @searchSkus="searchSkus"
                              ></SelectSkus>

                            </div>
                          </div>
                        </div>
                      </div>

                    <!-- <div class="form-group">
                      <label>Product SKUs</label>
                      <textarea
                        row="6"
                        type="text"
                        class="form-control"
                        placeholder="*** กรุณาใส่ ' , ' ระหว่างรหัสสินค้าด้วยนะจ๊ะ ตัวอย่างเช่น P084,P085,P086"
                        v-model="language.skus"
                      ></textarea>
                    </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group float-right">
            <a
              href="javascript:void(0)"
              onclick="javascript:window.history.back(); return false;"
              class="btn btn-secondary"
              >ยกเลิก</a
            >
            <button
              type="button"
              class="btn btn-primary ml-5"
              @click="saveWithGoBack()"
            >
              บันทึก
            </button>
            <button
              type="button"
              v-if="!this.item_id"
              class="btn btn-primary ml-5"
              @click="saveWithMore()"
            >
              บันทึก และ บันทึกเพิ่ม
            </button>
          </div>
          
        </div>
      </div>
    </form>
  </div>
</template>

<script>
//https://www.npmjs.com/package/vue-search-select

// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

// import { VueEditor, Quill } from 'vue2-editor' //https://npm.io/package/vue2-quill-editor
// import { ImageResize } from 'quill-image-resize-module';
// import htmlEditButton from "quill-html-edit-button"; //เพื่อใช้ HTML view button ตอนนี้ปิดไว้ก่อน
// import QuillBetterTable from 'quill-better-table' //เพื่อใช้ table ร่วมกับ vue2-editor ตอนนี้ปิดไว้ก่อน โหลดแล้วมีปัญหา

// Quill.register({'modules/ImageResize':ImageResize,'modules/htmlEditButton':htmlEditButton});

import SelectTags from "./selectTags";
import SelectSkus from "./selectSkus";
// import SelectThumbnail from './selectThumbnail'

import VueSelectImage from "vue-select-image"; //https://npm.runkit.com/vue-select-image สำหรับเลือกภาพ thumbnail
require("vue-select-image/dist/vue-select-image.css");

import searchbox from "../_layouts/searchbox.vue";

export default {
  props: {
    item_id: "", //เก็บ id ของ cms กรณีที่เป็นการแก้ไข
  },
  components: {
    // VueEditor,
    SelectTags,
    SelectSkus,
    // SelectThumbnail,
    // htmlEditButton,
    VueSelectImage,
    searchbox,
  },
  data() {
    return {
      form: {
        thumbnail: { id: "", url: "" , mime_type: "" },
        category_id: "",
        slug: "",
        post_type: "post",
        comment_status: "disallow",
        status: "draft",
        languages: [
          {
            h1: "",
            canonical: "",
            excerpt: "",
            title: "",
            meta_description: "",
            og_title: "",
            og_description: "",
            meta_keyword: "",
            site_name: "",
            og_image: "",
            og_image_type: "",
            og_image_height: "",
            og_image_width: "",
            og_url: "",
            og_locale: "",
            twitter_card: "",
            twitter_creator: "",
            twitter_title: "",
            twitter_site: "",
            twitter_domain: "",
            link_rel_alternate_hreflang: "",
            structured_data:"",
            language_id:"",
            language_parts: [
              {
                skus: [], //เพื่อเก็บและใช้ในตัวเลือก skus บนฟอร์ม
              }
            ],
          }
        ],
      },
      validateError: {
        // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ
        category_id: { error: false, message: "" },
        slug: { error: false, message: "" },
        post_type: { error: false, message: "" },
        comment_status: { error: false, message: "" },
        status: { error: false, message: "" },
        languages: { error: false, message: "" },
        thumbnail: { error: false, message: "" },
        title: { error: false, message: "" },
        h1: { error: false, message: "" },
      },
      errors: {},
      languages: [
        { title: '', h1: '' }, 
        { title: '', h1: '' }, 
        { title: '', h1: '' }, 
      ],
      content: "",
      editorOption: {
        modules: {
          htmlEditButton: { buttonHTML: "HTML" },
          ImageResize: { displaySize: true },
          toolbar: [
            // [{ 'font': ['','Prompt','Serif','Tahoma', 'Times-new-roman', 'Arial','Monospace']  }],
            [{ font: [] }],
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["link", "image"], // link and image
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"], // remove formatting button
          ],
        },
        placeholder: "ใส่เนื้อหาที่นี่",
        theme: "snow",
        height: "400",
      },

      categories: {}, //เพื่อเก็บและใช้ในตัวเลือก category_id  บนฟอร์ม
      tags: [], //เพื่อเก็บและใช้ในตัวเลือก tags บนฟอร์ม
      medias: [], //thumbnail
      languages: [],

      ProductSkus: {},
      skus: [], //เพื่อเก็บและใช้ในตัวเลือก skus บนฟอร์ม
      lastSelectSkus: {},

      base_url: "/cms", // base url (เปลี่ยน)
      base_url_sku: "/product", // base url sku (เปลี่ยน)

      lastSelectTag: {}, //เป็นตัวแปรสำหรับ input tags

      thumbnails: [
        // {
        // id: '5',
        // src: 'https://picsum.photos/100/200?random=5',
        // alt: 'รักน้องนวน',
        // disabled: false
        // }, {
        // id: '6',
        // src: 'https://picsum.photos/200/200?random=6',
        // alt: 'รักน้องนวน สาวงามพิจิตรน่าพิศชวนมอง',
        // disabled: false
        // }
      ],
    };
  },
  mounted() {
    //console.log('Component mounted.')
  },
  created() {
    this.fetchCategories();
    // this.fetchProductSkus();
  },
  methods: {
    onEditorBlur(quill) {
      // console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      // console.log('editor focus!', quill)
    },
    onEditorReady(quill) {
      // console.log('editor ready!', quill)
    },
    onEditorChange({ quill, html, text }, langIdx, partIdx) {
      // console.log("editor change!", quill, html, text);
      // this.content = html
      this.languages[langIdx].language_parts[partIdx].content = html;
    },
    load() {
      console.log("this.item_id >>>>>>>>>>>",this.item_id);

      axios
        .get(this.base_url + "/" + this.item_id)
        .then((response) => {

          // console.log(response.data.post[0]);
          let cms = response.data.post[0];
          // console.log("response thumb",response);
          if (cms.thumbnail == null) {
            this.form.thumbnail = { id: "", url: "", mime_type: "" };
          } else {
            this.form.thumbnail = {
              id: cms.thumbnail.id,
              url: cms.thumbnail.url,
              mime_type: cms.thumbnail.mime_type,
            };
          }
          // console.log("language check before",this.form.language);
          // console.log("this.form.thumbnail",this.form.thumbnail);
          // this.form.thumbnail = cms.thumbnail.id ? {id:cms.thumbnail.id, url:cms.thumbnail.url} : {id:'', url:''};
          this.form.category_id = cms.category_id;
          this.form.comment_status = cms.comment_status;
          this.form.post_type = cms.post_type;
          this.form.slug = cms.slug;
          this.form.status = cms.status;
          // console.log("this.form.slug",this.form.slug);

          //ดึง content ในแต่ละภาษา และ ในแต่ละส่วนของภาษา
          cms.languages.forEach((language, idx) => {
            this.form.languages[idx].h1= language.h1 ? language.h1 : language.title;
            this.form.languages[idx].canonical = language.canonical ? language.canonical : language.language_id == "1" ? this.form.slug + "/"  : "/en/" + this.form.slug + "/" ;
            
            this.form.languages[idx].excerpt = language.excerpt ? language.excerpt : "";
            this.form.languages[idx].title = language.title;
            this.form.languages[idx].meta_description = language.meta_description;
            this.form.languages[idx].og_title = language.og_title ? language.og_title : language.title;
            this.form.languages[idx].og_description = language.og_description ? language.og_description : language.meta_description;
            this.form.languages[idx].meta_keyword = language.meta_keyword;
            this.form.languages[idx].og_sitename = language.og_sitename ? language.og_sitename : "@wreathmala";
            this.form.languages[idx].og_locale = language.og_locale ? language.og_locale : language.code; // language.code undefined
            this.form.languages[idx].twitter_card = language.twitter_card ? language.twitter_card : "summary";
            this.form.languages[idx].twitter_creator = language.twitter_creator ? language.twitter_creator : "@wreathmala";
            this.form.languages[idx].twitter_title = language.twitter_title ? language.twitter_title : language.title;
            this.form.languages[idx].twitter_site = language.twitter_site ? language.twitter_site : "https://www.wreathmala.com/";
            this.form.languages[idx].twitter_domain = language.twitter_domain ? language.twitter_domain : "https://www.wreathmala.com/";
            // Header For old Article
            this.form.languages[idx].header = language.header;
            this.form.languages[idx].og_url = language.og_url ? language.og_url : language.language_id == "1" ? this.form.slug + "/" : "/en/" + this.form.slug + "/";
            this.form.languages[idx].og_image = language.og_image ? language.og_image : this.form.thumbnail.url;
            this.form.languages[idx].og_image_type = language.og_image_type ? language.og_image_type : this.form.thumbnail.mime_type;
            this.form.languages[idx].og_image_height = language.og_image_height ? language.og_image_height : 630;
            this.form.languages[idx].og_image_width = language.og_image_width ? language.og_image_width : 1200;
            this.form.languages[idx].link_rel_alternate_hreflang = language.link_rel_alternate_hreflang ? language.link_rel_alternate_hreflang : language.language_id == "1" ? this.form.slug + "/" : "/en/" + this.form.slug + "/" ;
            this.form.languages[idx].structured_data = language.structured_data ? language.structured_data : "";
            
            // console.log("languagetags0.1",language.tags);
            // console.log("language.language_parts",language.language_parts);


            language.tags.forEach((item) => {
              // console.log("language.HERE TAG");
              this.form.languages[idx].tags.push({
                value: item.id,
                text: item.name,
              });
            });
            
            language.language_parts.forEach((part, idy) => {

              // console.log("part content",part);
              // console.log("part.skus",part.skus);
              // console.log("item 935",item);

              this.form.languages[idx].language_parts[idy].content =
                part.content;

              // ตรวจสอบว่า part.skus มีค่าและเป็นสตริงหรือไม่
              if (part.skus && typeof part.skus === 'string') {
                  // แยกค่าของ skus โดยใช้ split ถ้า part.skus ไม่เป็น null
                  let skusSpit = part.skus.split(",");

                  if (skusSpit) {
                      skusSpit.forEach((partSkus) => {
                          if (partSkus !== null && partSkus.trim() !== '') { 
                              this.form.languages[idx].language_parts[idy].skus.push({
                                  value: partSkus,
                                  text: partSkus,
                              });
                          }
                      });
                  }
              }
            });

          });

          console.log("this.form",this.form);
        })
        .catch((errors) => {
          alert("loading Error", errors);
          console.log(errors);
        });
    },
    saveWithGoBack() {
      this.save("");
    },
    saveWithMore() {
      this.save("more");
    },
    save(whatNext) {
      let save_url = "";

      //เอา content จาก summernote ใน iframe ของแต่ละภาษา และ แต่ละ part ของภาษาเข้าไปใส่ใน this.form.languages
      this.get_language_from_ifram();

      if (this.item_id != "") {
        save_url = this.base_url + "/" + this.item_id + "/update";
      } else {
        save_url = this.base_url;
      }

      let me = this;
      //console.log(this.form);

      //เคลียร์ error ก่อนหน้า
      // let fields = Object.keys(this.form);
      // fields.forEach(function (item) {
      //   me.validateError[item].error = false;
      // });

      console.log("this.form",this.form);  // return;
      axios
        .post(save_url, this.form)
        .then((response) => {
          console.log("response",response);
          // return;
          response.status == "200" 
          ? whatNext == "more" 
            ? window.location.href = this.base_url + "/form"
            : window.location.href = this.base_url
          : alert("Error Status:",response.status);
          // if (whatNext == "more") {
          //   // reload form
          //   window.location.href = this.base_url + "/form";
          // } else {
          //   // go back
          //   // window.location.href = this.base_url;
          //   // history.back();
          // }
        })
        .catch((error) => {
          console.log("error.response:", error.response)
          if (error.response || error.response.status === 422) {
            this.errors = error.response.data.message; 
            alert("ไม่สามารถบันทึกได้ กรุณาใส่Content หรือ อย่าใส่content ข้ามส่วนนะจ๊ะ " + this.errors);
          }
          console.log("errors:",this.errors);
          // if (errors.response.data.message) {
          //   let errorMessage = errors.response.data.message;
          //   console.log("errorMessage:",errorMessage);
          //   let fields = Object.keys(this.form);
           
          //   fields.forEach(function (item) {
          //     //console.log("item",item);
          //     if (typeof errorMessage[item] != "undefined") {
          //       me.validateError[item].error = true;
          //       me.validateError[item].message = errorMessage[item][0];
          //     }
          //   });
          // } else {
          //   console.log("error save:",errors.response.data._infos.result);
          //   alert("ไม่สามารถบันทึกได้ อาจลืมใส่ข้อมูลบางช่อง " + errors.response.data._infos.result);
          // }
        });
    },
    get_language_from_ifram() {
      let iframe = {};
      let iWindow = {};
      let iDocument = {};
      let element = {};


      this.languages.forEach((item, langIdx) => {
        for (let partIdx = 0; partIdx <= 6; partIdx++) {
          iframe = document.getElementById(
            "iframe_language_" + item.id + "_part_" + partIdx
          );
          iWindow = iframe.contentWindow;
          iDocument = iWindow.document;

          element = iDocument.getElementById("summernote_code");

          this.form.languages[langIdx].language_parts[partIdx].content =
            element.value;

        }
      });
    },
    fetchCategories(url) {
      url = url || "/cms/fetchCategories";
      axios
        .get(url)
        .then((response) => {
          this.categories = response.data.items;
          this.fetchTags();
          this.fetchSkus();
          // this.fetchProductSkus();
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    searchTags(searchText) {
      // this.item = $event
      // console.log(searchText)
      this.fetchTags("/cms_tag/list?name=" + searchText, true);
    },
    fetchTags(url, search = false) {
      url = url || "/cms_tag/list";
      axios
        .get(url)
        .then((response) => {
          let tags = response.data.post_tags;
          let convertedTags = [];
          let i = 0;
          Object.entries(tags).forEach((tag) => {
            // console.log(tag);
            convertedTags[i] = { value: tag[1].id, text: tag[1].name };
            i++;
          });
          this.tags = convertedTags;
          // console.log(convertedTags);
          if (!search) {
            this.fetchLanguages();
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    searchMedias(searchText) {
      // this.item = $event
      // console.log(searchText)
      this.fetchMedias("/cms_tag/list?name=" + searchText, true);
    },
    fetchMedias(url, search = false) {},

    searchSkus(searchTextSkus) {
      // this.item = $event
      if (searchTextSkus.length >= 3) {
        // console.log("searchTextSkus CMS:",searchTextSkus)
        this.fetchSkus(this.base_url_sku +"/list/?keyword=" + searchTextSkus, true);
      }
      
      
    },
    fetchSkus(url, search = false) {
      url = url || this.base_url_sku +"/list";
      console.log("url",url);
      axios
        .get(url)
        .then((response) => {
          let skus = response.data.products.items;
          // console.log("response 1115:",response);
          let convertedSkus = [];
          let i = 0;
          if (skus.length != 0) {
            Object.entries(skus).forEach((sku) => {
              // console.log("skus 1156",sku);
              convertedSkus[i] = { value: sku[1].code_in_store, text: sku[1].code_in_store };
              i++;
            });
            this.skus = convertedSkus;
          }

          // console.log("convertedSkus",convertedSkus);
          // console.log("skus after convert",this.skus);
          // console.log("skus after convert text >>>>",skus.text);
          if (!search) {
            this.fetchLanguages();
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    searchMediasSkus(searchTextSkus) {
      // this.item = $event
      // console.log(searchText)
      this.fetchMediasSkus(this.base_url_sku +"/list/?keyword=" + searchTextSkus, true);
    },
    fetchMediasSkus(url, search = false) {},

    fetchLanguages(url) {
      url = url || "/fetch/language";
      axios
        .get(url)
        .then((response) => {
          this.languages = response.data.items;

          this.languages.forEach((item, idx) => {
            this.languages[idx].title = "";
            this.languages[idx].excerpt = "";
            this.languages[idx].tags = [];
            this.languages[idx].skus = [];
            this.languages[idx].language_parts = [
              { id: 1, content: "",skus : [], clicked: true },
              { id: 2, content: "",skus : [], clicked: false },
              { id: 3, content: "",skus : [], clicked: false },
              { id: 4, content: "",skus : [], clicked: false },
              { id: 5, content: "",skus : [], clicked: false },
              { id: 6, content: "",skus : [], clicked: false },
              { id: 7, content: "",skus : [], clicked: false },
            ];
          });
          this.form.languages = this.languages;
          // console.log("this.form.languages line 956",this.form.languages);
          if (this.item_id) {
            this.load(); // load items ถ้ามีระบุ item_id มาจาก หน้า edit
          }
        })
        .catch((errors) => {
          alert("Unable to load Languge " + errors.message);
          console.log(errors);
        });
    },
    languageTabClicked(langIdx = 0) {
      console.log("langIdx",langIdx);
      this.form.languages.forEach((item, idx) => {
        this.form.languages[idx].clicked = false;
      });
      this.form.languages[langIdx].clicked = true;
    },
    onContentPartTabClicked(langIdx, partIdx) {
      this.languageTabClicked(langIdx);

      this.form.languages[langIdx].language_parts.forEach(function (part, y) {
        if (y == partIdx) {
          part.clicked = true;
        } else {
          part.clicked = false;
        }
      });
    },
    seachThumbnail(searchKeword) {
      this.thumbnails = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            // console.log(item);
            this.thumbnails.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    onSelectImage(data) {
      console.log(data);
      this.form.thumbnail.url = data.src;
      this.form.thumbnail.id = data.id;
    },
  },
};
</script>
<style scoped>
.ql-editor {
  max-height: 300px !important;
  min-height: 300px !important;
  overflow: auto;
}
#language_content_0 {
    background-color: #b0c4de; /* Active background color */
    color: black;
    padding: 20px;
}
#language_content_1 {
    background-color: #faebd7; /* Active background color */
    color: black;
    padding: 20px;
}
</style>